import { render, staticRenderFns } from "./MetadataForm.vue?vue&type=template&id=69f5ca51&"
import script from "./MetadataForm.vue?vue&type=script&lang=ts&"
export * from "./MetadataForm.vue?vue&type=script&lang=ts&"
import style0 from "./MetadataForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports